import {Grid, Typography, Box} from '@mui/material';

import {StatusItem} from './AnalyticsSection';
import {orangeColors} from '../../../../layouts/theme/designSystem';

interface Props {
  statuses: StatusItem[];
}

export const AnalyticsStatusRow = ({statuses}: Props) => {
  return (
    <Grid container spacing={2} justifyContent='center'>
      {statuses.map((status, index) => (
        <Grid item key={index}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 2,
              border: status.selected ? `1px solid ${orangeColors[3]}` : 'none',
              borderColor: orangeColors[3],
              backgroundColor: '#fff',
              borderRadius: '8px',
              minWidth: '200px',
            }}
          >
            <Typography variant='h4'>{status.label}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
